<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';

    onMount(() => {
        navigate('/comparador', { replace: true });
    });
</script>
